import { render, staticRenderFns } from "./PrivacyPolicyFR.vue?vue&type=template&id=bc3515da&scoped=true"
import script from "./PrivacyPolicyFR.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyFR.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyFR.vue?vue&type=style&index=0&id=bc3515da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3515da",
  null
  
)

export default component.exports